import { observer } from "mobx-react";
import React, { useState } from "react";
import { Stack, Button, TextInput, Select } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { notifications } from "@mantine/notifications";

const TwoFaSettings = observer(({ cubby }: { cubby: Cubby }) => {
  const [selectedInterval, setSelectedInterval] = useState<string | null>(
    cubby.two_fa_interval_minutes.toString()
  );
  const [twoFactorCode, setTwoFactorCode] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const intervals = [
    { value: "1", label: "1 minute" },
    { value: "20", label: "20 minutes" },
    { value: "720", label: "12 hours" },
    { value: "1440", label: "24 hours" },
    { value: "10080", label: "1 week" },
    { value: "43200", label: "30 days" },
  ];

  const handleSave = () => {
    // Remove spaces and validate 2FA code
    cubby.setTwoFaIntervalErrorMessage(null);
    const sanitizedCode = twoFactorCode.replace(/\s/g, "");
    if (!/^\d{6}$/.test(sanitizedCode)) {
      cubby.setTwoFaIntervalErrorMessage(
        "Invalid 2FA code. Please enter a 6-digit number."
      );
      return;
    }

    // console.log("ask about 2fa code");

    // Call cubbyFastInfo with the new interval and 2FA code
    cubby.cubbyFastInfo("modify_2fa_interval", {
      newIntervalMinutes: Number(selectedInterval),
      twoFactorCode: sanitizedCode,
    });

    notifications.show({
      color: "blue",
      title: "Modified 2FA Timeout ",
      message:
        "Please wait a few seconds and then reload the page. To confirm the new timeout has been set, open the settings again after you reload the page.",
    });

    // console.log("here is the result from modify twofa interval", twoFaResult);
    // setErrorMessage(null); // Clear any previous errors
    // alert("2FA interval updated successfully!");
  };

  return (
    <Stack gap="sm">
      <Select
        label="2FA Timeout"
        placeholder="Select timeout interval"
        data={intervals}
        value={selectedInterval}
        onChange={setSelectedInterval}
      />
      <TextInput
        label="Current 2FA Code"
        placeholder="Enter 2FA code"
        value={twoFactorCode}
        onChange={(e) => setTwoFactorCode(e.target.value)}
        error={cubby.twoFaIntervalErrorMessage}
      />
      <Button
        onClick={() => handleSave()}
        disabled={!selectedInterval || !twoFactorCode}
      >
        Change 2FA Timeout
      </Button>
    </Stack>
  );
});

export default TwoFaSettings;
